import { imageWithTextSchema } from '../image-with-text/schema.js';
/**
 * video-with-text — the SAME engine as `image-with-text` (identical split layout + composable content-column
 * blocks + the shared `video` media field), registered under its OWN clearly-named entry so sellers find it
 * fast in Add-section ("Image with text" doesn't read as "put a video here" — founder ask 2026-07-26).
 *
 * NO logic duplication: it reuses `ImageWithText` (the Component renders the media column's `video` field over
 * the still image) and spreads `imageWithTextSchema` (same fields / accepts / child block schemas), overriding
 * only `type` + `name`. The only bespoke bit is the preset — video-first copy + video toggles pre-seeded.
 */
export const videoWithTextSchema = {
    ...imageWithTextSchema,
    type: 'video-with-text',
    name: 'Video with text',
};
export const videoWithTextPresets = [
    {
        name: 'Video with text',
        settings: {
            // No default video — a fresh instance ships EMPTY so the seller uploads their own; the empty media
            // column renders the neutral placeholder until they do.
            layout: 'start',
            imageWidth: 50,
            imageRatio: 'adapt',
            verticalAlignment: 'middle',
            colorScheme: 'light',
            paddingTop: 88,
            paddingBottom: 88,
            width: 'standard',
            // No video playback settings — a video always renders like an image (silent autoplay loop, no chrome).
        },
        blocks: [
            {
                type: 'heading',
                settings: {
                    title: { format: 'html', html: 'Voir le produit en action' },
                    headingSize: 'h1',
                    alignment: 'left',
                    mobileAlignment: 'mobile-center',
                },
            },
            {
                type: 'text',
                settings: {
                    text: {
                        format: 'html',
                        html: '<p>Une courte vidéo vaut mille mots : montrez votre produit en situation réelle.</p>',
                    },
                    alignment: 'left',
                    mobileAlignment: 'center',
                },
            },
            {
                type: 'button',
                settings: {
                    button_label: '@t:product.buy_now',
                    alignment: 'flex-start',
                    mobile_alignment: 'center',
                },
            },
        ],
    },
];
/**
 * How this section presents itself in "Add section": label, group, icon.
 *
 * Beside the schema rather than in `index.ts` for the same reason as every other section: `index.ts` is what
 * pulls the render code in, and the builder needs `meta` for all sixty-two to paint the picker. See
 * `registry.lazy.gen.ts`.
 */
export const videoWithTextMeta = {
    label: 'Video with text',
    group: 'Content',
    icon: 'video',
};
//# sourceMappingURL=schema.js.map